import { useState } from "react";
import { Link } from "react-router-dom";
import { Eye, EyeOff, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mostra, setMostra] = useState(false);
  const [errore, setErrore] = useState("");
  const [busy, setBusy] = useState(false);
  const [ricordami, setRicordami] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErrore("");
    const r = await login(email.trim(), password, ricordami);
    if (!r.ok) setErrore(r.error);
    setBusy(false);
  };

  const inp = "w-full border border-slate-200 rounded-md px-3 py-2.5 text-sm bg-white text-slate-800 " +
    "focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-400 transition-colors duration-200";

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src="/dbe-logo.png" alt="DBE Consulenza Finanziaria"
            className="h-24 w-auto" data-testid="login-logo" />
          <div className="text-[10px] uppercase tracking-[0.24em] text-slate-400 mt-2">Gestionale 2026</div>
        </div>

        <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-7">
          <h1 className="text-2xl font-semibold text-slate-900">Accedi</h1>
          <p className="text-sm text-slate-500 mt-1">Area riservata alla direzione commerciale.</p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form" autoComplete="on">
            <div>
              <label className="block text-[10px] uppercase tracking-[0.14em] font-bold text-slate-500 mb-1">Email</label>
              <input className={inp} type="email" value={email} data-testid="login-email" name="email" id="email"
                autoComplete="username" inputMode="email"
                onChange={(e) => setEmail(e.target.value)} placeholder="nome@agenzia-dbeasy.it" />
            </div>
            <div>
              <label className="block text-[10px] uppercase tracking-[0.14em] font-bold text-slate-500 mb-1">Password</label>
              <div className="relative">
                <input className={`${inp} pr-10`} type={mostra ? "text" : "password"} value={password}
                  data-testid="login-password" name="password" id="current-password"
                  autoComplete="current-password"
                  onChange={(e) => setPassword(e.target.value)} />
                <button type="button" onClick={() => setMostra((v) => !v)} data-testid="login-mostra-password"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700 transition-colors duration-200">
                  {mostra ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>
            <label className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer select-none">
              <input type="checkbox" checked={ricordami} data-testid="login-ricordami"
                onChange={(e) => setRicordami(e.target.checked)}
                className="h-4 w-4 rounded border-slate-300 text-sky-600 focus:ring-sky-400" />
              Ricordami su questo dispositivo
            </label>
            {errore && (
              <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2"
                data-testid="login-errore">{errore}</div>
            )}
            <button type="submit" disabled={busy || !email || !password} data-testid="login-submit"
              className="w-full inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-sky-600
                text-white text-sm font-semibold hover:bg-sky-700 disabled:opacity-50
                disabled:cursor-not-allowed transition-colors duration-200">
              <LogIn size={16} /> {busy ? "Accesso…" : "Login"}
            </button>
          </form>

          <Link to="/password-dimenticata" data-testid="link-password-dimenticata"
            className="block text-center text-xs text-sky-700 hover:text-sky-900 mt-5 transition-colors duration-200">
            Password dimenticata?
          </Link>
        </div>
      </div>
    </div>
  );
}
